import React from 'react';
import { Button, Dialog } from '@biq/apex-ui';
import { DialogContent, Grid, Typography } from '@mui/material';
import { CancelModalProps, styles } from './cancel-modal-helper';

export const CancelModal = ({
    cancelModal,
    handleCancelModal,
    cancelButtonText,
    cancelHeadingText,
    cancelSubHeadingText,
    cancelModalText = 'Cancel',
    handleCancel,
    children,
}: CancelModalProps): React.JSX.Element => {
    return (
        <Dialog
            closable={true}
            open={cancelModal}
            onClose={handleCancelModal}
            title={cancelHeadingText}
            sx={styles.dialogStyles}
        >
            <DialogContent>
                <Grid>
                    <Typography>{cancelSubHeadingText}</Typography>
                </Grid>
                <Grid>{children}</Grid>
                <Grid sx={styles.buttonContainer}>
                    <Button size='large' color='error' onClick={handleCancel}>
                        {cancelButtonText}
                    </Button>
                    <Button
                        size='large'
                        variant='text'
                        onClick={handleCancelModal}
                    >
                        {cancelModalText}
                    </Button>
                </Grid>
            </DialogContent>
        </Dialog>
    );
};
